import { createActions } from 'redux-actions'


export const {
  storeUserProfile
} = createActions(
  'STORE_USER_PROFILE',
)